import type { GalleryModalProps } from './data';

import React from 'react';

import GalleryModalTabPanel from '../GalleryModalTabPanel';

import {
  Box,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  Tab,
  TabIndicator,
  TabList,
  TabPanels,
  Tabs,
} from '@/components';
import { useTranslation } from '@/hooks';

const GalleryModal: GalleryModalProps = ({
  onClose,
  isOpen,
  galleryImages,
  userImages,
  initialSlide,
  tabIndex,
  setTabIndex,
}) => {
  const { t } = useTranslation('pages.products');

  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <Box zIndex="modal">
            <ModalCloseButton fill="black" />
          </Box>
          <ModalBody px="12px" pb="22px">
            <Tabs variant="line" index={tabIndex} onChange={setTabIndex}>
              <TabList gap={{ base: '5', md: '10' }} pr={{ md: '2' }}>
                <Tab
                  px="2"
                  pb="2"
                  color="text"
                  fontWeight={700}
                  fontSize={{ base: 'sm', md: 'md' }}
                  _selected={{ color: 'primary.500' }}
                >
                  {t('productPhotos')}
                </Tab>
                <Tab
                  px="2"
                  pb="2"
                  color="text"
                  fontWeight={700}
                  fontSize={{ base: 'sm', md: 'md' }}
                  _selected={{ color: 'primary.500' }}
                >
                  {t('customerPhotos')}
                </Tab>
              </TabList>
              <TabIndicator mt="-2px" height="2px" bg="primary.500" />
              <TabPanels mt="5">
                <GalleryModalTabPanel
                  galleryImages={galleryImages || []}
                  initialSlide={initialSlide}
                />
                <GalleryModalTabPanel
                  galleryImages={userImages || []}
                  initialSlide={initialSlide}
                />
              </TabPanels>
            </Tabs>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};

export default GalleryModal;
